<app-menu></app-menu>
<mat-toolbar class="flexSpace" color="primary">
  Manage global configs

  <button
    [ngClass]="selectedClass"
    mat-flat-button
    [matMenuTriggerFor]="testAreas"
  >
    {{ selectedTestArea.toString() }}
  </button>
  <mat-menu style="display: flex; flex-direction: column" #testAreas="matMenu">
    <button
      class="embargo"
      mat-menu-item
      (click)="selectTestArea(testArea.EMBARGO)"
    >
      {{ testArea.EMBARGO.toString() }}
    </button>
    <button
      class="pre-prod"
      mat-menu-item
      (click)="selectTestArea(testArea.PREPROD)"
    >
      {{ testArea.PREPROD.toString() }}
    </button>
    <button class="prod" mat-menu-item (click)="selectTestArea(testArea.PROD)">
      {{ testArea.PROD.toString() }}
    </button>
  </mat-menu>
</mat-toolbar>
<mat-card>
<table
mat-table
[dataSource]="dataSource"
>
<ng-container matColumnDef="fileName">
  <th mat-header-cell *matHeaderCellDef>File Name</th>
  <td mat-cell *matCellDef="let row">{{ row.fileName }}</td>
</ng-container>
<ng-container matColumnDef="showFileContent">
  <th mat-header-cell *matHeaderCellDef>File content</th>
  <td mat-cell *matCellDef="let row"><button mat-raised-button color="accent" (click)="showFileContent(row.content)">Show</button></td>
</ng-container>

<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

</table>
</mat-card>
<mat-card>
<button mat-button color="primary"><h3>Select xml-file/s to upload:</h3></button>
<mat-card class="mat-elevation-z0">
  <mat-card-actions>
    <button mat-flat-button color="primary" (click)="onClick()">
      <mat-icon>attach_file</mat-icon>
      Browse
    </button>
  </mat-card-actions> </mat-card
><input
  type="file"
  (change)="selectFiles($event)"
  #fileInput
  id="fileUpload"
  name="fileUpload"
  multiple
  accept="*.xml"
  style="display: none"
/>

<mat-card class="mat-elevation-z0">
  <mat-card-content>
    <ul>
      <li *ngFor="let progressInfo of progressInfos">
        <span id="file-label">
          {{ progressInfo.fileName }}
        </span>
        <mat-progress-bar [value]="progressInfo.value"></mat-progress-bar>
        <span>{{ progressInfo.value }}% </span>
      </li>
    </ul>
  </mat-card-content>
  <mat-card-actions>
    <button mat-flat-button color="primary" [disabled]="!validatedFiles" (click)="upload()">
      <mat-icon>file_upload</mat-icon>
      Upload
    </button>
  </mat-card-actions>
</mat-card>
</mat-card>
